import React from "react";
import { useDocumentTitle } from "../hooks/useDocumentTitle";

function Links() {
    useDocumentTitle("Links");
    return (
        <div className="w-100 d-flex justify-content-center align-items-center m-5 flex-column" style={{height: "50vh"}}>
            <h1 className="visually-hidden">Links</h1>
            <img
                src="https://fg-a.com/under-construction/1-construction-animated-2.gif"
                alt="Under construction"
            />
            <p>This page is under construction. Check back soon!</p>
        </div>
    );
}

export default Links;
